import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { validateBusinessPartners } from 'common/formValidation/settings';

import Dropdown from 'components/Dropdown';
import FormButtons from 'components/FormButtons';
import { GridLayout } from 'components/form/layout';
import { TextField, PasswordField, YesNoField } from 'components/form/field';
import { scrollToNext } from 'utils/scrollToNext';
import { sortBusinessPartners } from './useBusinessPartners';

const BusinessPartnerDropdown = ({ name, businessPartner, isActive, toggleActive }) => {
    const onToggleActive = useCallback(async (e) => {
        e.preventDefault();

        const confirmMessage = isActive ? 'Désactiver ce partenaire ?' : 'Réactiver ce partenaire ?';

        if (window.confirm(confirmMessage)) {
            await toggleActive(businessPartner, !isActive);
        }
    }, [businessPartner, isActive, toggleActive]);

    return (
        <Dropdown title={`${isActive ? '' : '(désactivé) '}${name}`}>
            <GridLayout className="double condensed full-width">
                <TextField
                    name={`businessPartner.${businessPartner}.name`}
                    title="Nom"
                    nombreCaractereMax={15}
                />
                <TextField
                    name={`businessPartner.${businessPartner}.grantType`}
                    title="Grant Type"
                />
                <TextField
                    name={`businessPartner.${businessPartner}.clientId`}
                    title="Client ID"
                />
                <TextField
                    name={`businessPartner.${businessPartner}.urlSouscription`}
                    title="URL de souscription"
                />
                <PasswordField
                    name={`businessPartner.${businessPartner}.clientSecret`}
                    title="Client secret"
                    autoComplete="new-password"
                />
                <TextField
                    name={`businessPartner.${businessPartner}.urlToken`}
                    title="URL token"
                />
                <YesNoField
                    name={`businessPartner.${businessPartner}.hasManagementAct`}
                    title="Acte de gestion"
                />
            </GridLayout>
            <hr />
            <button className="theseis-btn" onClick={onToggleActive}>
                {isActive ? 'Désactiver' : 'Réactiver'}
            </button>
        </Dropdown>
    );
};

BusinessPartnerDropdown.propTypes = {
    name: PropTypes.string.isRequired,
    businessPartner: PropTypes.string.isRequired,
    isActive: PropTypes.bool.isRequired,
    toggleActive: PropTypes.func.isRequired,
};

// le "container" est porté par l'onglet : ce formulaire n'utilise pas FormFields pour ne pas l'imbriquer
const BusinessPartnerFormInner = ({ handleSubmit, businessPartners, toggleActive }) => (
    <form
        role="presentation"
        onSubmit={handleSubmit}
        onKeyDown={scrollToNext}
        id="business-partner-form"
    >
        {sortBusinessPartners(businessPartners).map(([businessPartner, { name, isActive }]) => (
            <BusinessPartnerDropdown
                key={businessPartner}
                name={name}
                businessPartner={businessPartner}
                isActive={isActive}
                toggleActive={toggleActive}
            />
        ))}
        <FormButtons
            back="/admin/settings"
            formId="business-partner-form"
            nextButtonContent="Enregistrer"
        />
    </form>
);

BusinessPartnerFormInner.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    businessPartners: PropTypes.shape({}).isRequired,
    toggleActive: PropTypes.func.isRequired,
};

const BusinessPartnerForm = reduxForm({
    form: 'settings-businessPartner-edit',
    enableReinitialize: true,
    validate: validateBusinessPartners,
    onSubmitSuccess: () => {
        document.location.reload();
    },
})(BusinessPartnerFormInner);

export default BusinessPartnerForm;
